import { useEffect } from 'react'
import './about.scss'
import { img_default_cover_app } from '../../../core/hooks/assetsConstants'

export default function About({ setPageTitle }: any) {

  // Nombre de la página
  const namePage = 'Acerca de';

  useEffect(() => {

    // Titulos de pagina
    setPageTitle(namePage);
    document.title = `${namePage} | SeñaTech`;

  }, [setPageTitle]);

  return (
    <section className='page content_about'>
      <div className='title_content'>
        <h1 className='title'>Acerca del diccionario SeñaTech</h1>
        <span className='description'>El conocimiento de la lengua de señas promueve el acceso, comunicación e información.</span>
      </div>

      <div className='about'>
        <div className='description_content'>
          <span>El acceso al conocimiento técnico es un pilar fundamental para promover la inclusión y el desarrollo profesional de todas las personas. Este diccionario técnico en lengua de señas ecuatoriana, especializado en vocabulario de la carrera de Ingeniería en Tecnologías de la Información, representa un esfuerzo pionero en nuestra comunidad.</span>

          <span>Desarrollado como parte del proyecto de integración curricular de la Universidad de las Fuerzas Armadas ESPE, este proyecto fue llevado a cabo por un estudiante sordo, quien además asumió los costos asociados a su elaboración. La plataforma, accesible en formato web, está diseñada para ser consultada por cualquier persona interesada, tanto de la comunidad sorda como oyente, fomentando la inclusión y el aprendizaje colaborativo.</span>

          <span>El diccionario organiza las señas en varias categorías técnicas y cuenta actualmente con más de 200 términos especializados. Además, se proyecta un crecimiento continuo hasta alcanzar al menos 1.000 palabras técnicas, respondiendo a las necesidades de los usuarios y al avance del campo tecnológico.</span>

          <h3 className='subtitle'>DESARROLLO</h3>

          <span>A través de gráficos y videos explicativos, los usuarios pueden aprender la correcta articulación de cada seña, facilitando una comunicación precisa y efectiva. Este diccionario no solo es una herramienta educativa, sino también un puente hacia una sociedad más accesible e inclusiva, motivando el interés por la comunidad sorda en el ámbito tecnológico.</span>
        </div>

        <div className='image_cover'>
          <div className='image_wrapper'>
            <img className='image' src={img_default_cover_app} alt="cover" />
          </div>
        </div>
      </div>

    </section>
  )
}
